export default __webpack_public_path__ + "static/media/PTSans-RegularItalic.468c5f35.ttf";